// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import App from './App'
// import router from './router'
import VueRouter from 'vue-router'
import VueVirtualScroller from 'vue-virtual-scroller'
import store from './store'

import login from './pages/login.vue'
import home from './pages/home.vue'
import welcome from './pages/welcome.vue'
import advertisingList from './pages/marketing/advertising/List.vue'
import advertisingAdd from './pages/marketing/advertising/Add.vue'
import advertisingEdit from './pages/marketing/advertising/Edit.vue'
import eventList from './pages/marketing/event/List.vue'
import eventAdd from './pages/marketing/event/Add.vue'
import eventEdit from './pages/marketing/event/Edit.vue'
import activityList from './pages/marketing/activity/List.vue'
import surveyList from './pages/marketing/survey/List.vue'
import surveyAdd from './pages/marketing/survey/Add.vue'
import surveyEdit from './pages/marketing/survey/Edit.vue'
import memberInfoList from './pages/member/info/List.vue'
import memberInfoEdit from './pages/member/info/Edit.vue'
import memberInfoBonusHistory from './pages/member/info/BonusHistory.vue'
import memberInfoExchangeHistory from './pages/member/info/ExchangeHistory.vue'
import memberInfoCouponHistory from './pages/member/info/CouponHistory.vue'
import memberInfoStorepayHistory from './pages/member/info/StorepayHistory.vue'
import memberRechargeList from './pages/member/recharge/List.vue'
import membermemberPush from './pages/member/memberPush/List.vue'
import storeMenuList from './pages/store/menu/List.vue'
import storeMenuEdit from './pages/store/menu/Edit.vue'
import storeMenuAdd from './pages/store/menu/Add.vue'
import couponExchangeList from './pages/coupon/exchange/List.vue'
import couponExchangeAdd from './pages/coupon/exchange/Add.vue'
import couponExchangeEdit from './pages/coupon/exchange/Edit.vue'
import couponGiveList from './pages/coupon/give/List.vue'
import couponGiveAdd from './pages/coupon/give/Add.vue'
import couponGiveEdit from './pages/coupon/give/Edit.vue'
import informationAdHitsRateList from './pages/information/adHitsRate/List.vue'
import informationPointsList from './pages/information/points/List.vue'
import informationCouponList from './pages/information/coupon/List.vue'
import informationCouponGiveList from './pages/information/coupongive/List.vue'
import informationActivityList from './pages/information/activity/List.vue'
import memberAward from './pages/memberAward.vue'
import memberActivity from './pages/memberActivity.vue'
import roleManagement from './pages/system/roleManagement.vue'
import roleManagementAdd from './pages/system/roleManagementAdd.vue'
import roleManagementEdit from './pages/system/roleManagementEdit.vue'
import userManagement from './pages/system/userManagement.vue'
import userManagementAdd from './pages/system/userManagementAdd.vue'
import userManagementEdit from './pages/system/userManagementEdit.vue'
import mailServerSetting from './pages/system/mailServerSetting.vue'
import smsSetting from './pages/system/smsSetting.vue'
import qaSetting from './pages/qa/qaSetting.vue'
import qaAdd from './pages/qa/Add.vue'
import qaEdit from './pages/qa/Edit.vue'
import posComboList from './pages/shopping/posCombo/List.vue'
import comboList from './pages/shopping/combo/List.vue' // 20200305 tina add  套餐管理
import comboAdd from './pages/shopping/combo/Add.vue'
import comboEdit from './pages/shopping/combo/Edit.vue'
import menuList from './pages/shopping/menu/List.vue'
import menuItemList from './pages/shopping/menu/ItemList.vue'
import productList from './pages/shopping/product/List.vue'
import productEdit from './pages/shopping/product/Edit.vue'
import plusList from './pages/shopping/plus/List.vue'
import orderSettingIndex from './pages/shopping/ordersetting/Index.vue'
import storeholidayIndex from './pages/shopping/storeholiday/Index.vue'
import dayTypeSetting from './pages/shopping/ordersetting/DayTypeSetting.vue'
import posCloseList from './pages/shopping/storeholiday/poscloselist.vue'
import orderControlSetting from './pages/shopping/ordersetting/OrderControlSetting.vue'
import storeOrderSetting from './pages/shopping/ordersetting/StoreOrderSetting.vue'
import storeWorkTime from './pages/shopping/ordersetting/StoreWorkTime.vue'
import storeholidayList from './pages/shopping/storeholiday/List.vue'
import StorePublicHolidaySetting from './pages/shopping/storeholiday/PublicHoliday.vue'
import informationMemberUseCouponList from './pages/information/memberusecoupon/List.vue' // 20200326 LinCY add 會員使用優惠券分析
import informationTicketHistoryList from './pages/information/tickethistory/List.vue' // 電子票券匣
import informationAppOrderList from './pages/information/apporder/List.vue' // 20200408 LinCY add APP訂購餐點分析
import informationPaymentList from './pages/information/payment/List.vue' // 20200413 LinCY add 第三方支付訂單查詢
import informationPaymentItemList from './pages/information/payment/ItemList.vue' // 20200413 LinCY add 第三方支付訂單查詢>明細
import informationPayForUseList from './pages/information/payforuse/List.vue' // 20200413 LinCY add 支付使用數據統計
import storeList from './pages/shopping/store/List.vue'
import storeIndex from './pages/shopping/store/Index.vue'
import storePaymentMemo from './pages/shopping/store/PaymentMemo.vue'
import flavorList from './pages/shopping/flavor/List.vue'
import extraList from './pages/shopping/extra/List.vue'
import flavorItemList from './pages/shopping/flavor/ItemList.vue'
import informationMemberAppOrderList from './pages/information/memberAppOrder/List.vue'
import informationAreaOrderList from './pages/information/areaOrder/List.vue'
import systemVersion from './pages/system/Version.vue'
import orderManageList from './pages/order/manage/List.vue' // 20211007 訂單管理
import orderPaymentList from './pages/order/payment/List.vue' // 20211007 支付匯總數據
import orderPeriodList from './pages/order/period/List.vue' // 20230427 餐期查詢

// init
Vue.use(VueRouter)
Vue.use(VueVirtualScroller)

Vue.config.productionTip = false

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'

// http request 攔截
axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('TOKEN')) {
      config.headers.Authorization = `Bearer ${localStorage.getItem('TOKEN')}`
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })

Vue.prototype.$http = axios

const router = new VueRouter({
  // 使用 HTML 5 模式（沒有 hash, ex: #/hello）
  mode: 'history',
  base: __dirname,
  // routre 表
  routes: [
    {
      path: '/home',
      // name: 'name',
      component: home,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'name',
          component: welcome,
          meta: { requiresAuth: true }
        },
        {
          path: '/marketing/advertising/list',
          name: 'advertising_list',
          component: advertisingList,
          meta: { requiresAuth: true }
        },
        {
          path: '/marketing/advertising/add',
          name: 'advertising_add',
          component: advertisingAdd,
          meta: { requiresAuth: true }
        },
        {
          path: '/marketing/advertising/edit',
          name: 'advertising_edit',
          component: advertisingEdit,
          meta: { requiresAuth: true }
        },
        {
          path: '/marketing/event/list',
          name: 'event_list',
          component: eventList,
          meta: { requiresAuth: true }
        },
        {
          path: '/marketing/event/add',
          name: 'event_add',
          component: eventAdd,
          meta: { requiresAuth: true }
        },
        {
          path: '/marketing/event/edit',
          name: 'event_edit',
          component: eventEdit,
          meta: { requiresAuth: true }
        },
        {
          path: '/marketing/activity/list',
          name: 'activity_list',
          component: activityList,
          meta: { requiresAuth: true }
        },
        {
          path: '/marketing/survey/list',
          name: 'survey_list',
          component: surveyList,
          meta: { requiresAuth: true }
        },
        {
          path: '/marketing/survey/add',
          name: 'survey_add',
          component: surveyAdd,
          meta: { requiresAuth: true }
        },
        {
          path: '/marketing/survey/edit',
          name: 'survey_edit',
          component: surveyEdit,
          meta: { requiresAuth: true }
        },
        {
          path: '/member/info/list',
          name: 'member_info_list',
          component: memberInfoList,
          meta: { requiresAuth: true }
        },
        {
          path: '/member/info/edit',
          name: 'member_info_edit',
          component: memberInfoEdit,
          meta: { requiresAuth: true }
        },
        {
          path: '/member/info/bonus_history',
          name: 'member_info_bonus_history',
          component: memberInfoBonusHistory,
          meta: { requiresAuth: true }
        },
        {
          path: '/member/info/exchange_history',
          name: 'member_info_exchange_history',
          component: memberInfoExchangeHistory,
          meta: { requiresAuth: true }
        },
        {
          path: '/member/info/coupon_history',
          name: 'member_info_coupon_history',
          component: memberInfoCouponHistory,
          meta: { requiresAuth: true }
        },
        {
          path: '/member/info/storepay_history',
          name: 'member_info_storepay_history',
          component: memberInfoStorepayHistory,
          meta: { requiresAuth: true }
        },
        {
          path: '/member/recharge/list',
          name: 'member_recharge_list',
          component: memberRechargeList,
          meta: { requiresAuth: true }
        },
        {
          path: '/member/memberPush/list',
          name: 'member_memberPush_list',
          component: membermemberPush,
          meta: { requiresAuth: true }
        },
        {
          path: '/store/menu/list',
          name: 'store_menu_list',
          component: storeMenuList,
          meta: { requiresAuth: true }
        },
        {
          path: '/store/menu/edit',
          name: 'store_menu_edit',
          component: storeMenuEdit,
          meta: { requiresAuth: true }
        },
        {
          path: '/store/menu/add',
          name: 'store_menu_add',
          component: storeMenuAdd,
          meta: { requiresAuth: true }
        },
        {
          path: '/coupon/exchange/list',
          name: 'coupon_exchange_list',
          component: couponExchangeList,
          meta: { requiresAuth: true }
        },
        {
          path: '/coupon/exchange/Add',
          name: 'coupon_exchange_add',
          component: couponExchangeAdd,
          meta: { requiresAuth: true }
        },
        {
          path: '/coupon/exchange/Edit',
          name: 'coupon_exchange_edit',
          component: couponExchangeEdit,
          meta: { requiresAuth: true }
        },
        {
          path: '/coupon/give/list',
          name: 'coupon_give_list',
          component: couponGiveList,
          meta: { requiresAuth: true }
        },
        {
          path: '/coupon/give/Add',
          name: 'coupon_give_add',
          component: couponGiveAdd,
          meta: { requiresAuth: true }
        },
        {
          path: '/coupon/give/Edit',
          name: 'coupon_give_edit',
          component: couponGiveEdit,
          meta: { requiresAuth: true }
        },
        {
          path: '/information/adHitsRate/list',
          name: 'information_adHitsRate_list',
          component: informationAdHitsRateList,
          meta: { requiresAuth: true }
        },
        {
          path: '/information/points/list',
          name: 'information_points_list',
          component: informationPointsList,
          meta: { requiresAuth: true }
        },
        {
          path: '/information/coupon/list',
          name: 'information_coupon_list',
          component: informationCouponList,
          meta: { requiresAuth: true }
        },
        {
          path: '/information/coupongive/list',
          name: 'information_coupongive_list',
          component: informationCouponGiveList,
          meta: { requiresAuth: true }
        },
        {
          path: '/information/activity/list',
          name: 'information_activity_list',
          component: informationActivityList,
          meta: { requiresAuth: true }
        },
        {
          path: '/home/member_award',
          name: 'member_award',
          component: memberAward,
          meta: { requiresAuth: true }
        },
        {
          path: '/home/member_activity',
          name: 'member_activity',
          component: memberActivity,
          meta: { requiresAuth: true }
        },
        {
          path: '/system/role_management',
          name: 'role_management',
          component: roleManagement,
          meta: { requiresAuth: true }
        },
        {
          path: '/system/role_management_add',
          name: 'role_management_add',
          component: roleManagementAdd,
          meta: { requiresAuth: true }
        },
        {
          path: '/system/role_management_edit',
          name: 'role_management_edit',
          component: roleManagementEdit,
          meta: { requiresAuth: true }
        },
        {
          path: '/system/user_management',
          name: 'user_management',
          component: userManagement,
          meta: { requiresAuth: true }
        },
        {
          path: '/system/user_management_add',
          name: 'user_management_add',
          component: userManagementAdd,
          meta: { requiresAuth: true }
        },
        {
          path: '/system/user_management_edit',
          name: 'user_management_edit',
          component: userManagementEdit,
          meta: { requiresAuth: true }
        },
        {
          path: '/system/mail_server_setting',
          name: 'mail_server_setting',
          component: mailServerSetting,
          meta: { requiresAuth: true }
        },
        {
          path: '/system/sms_setting',
          name: 'sms_setting',
          component: smsSetting,
          meta: { requiresAuth: true }
        },
        {
          path: '/qa/qaSetting',
          name: 'qa_setting',
          component: qaSetting,
          meta: { requiresAuth: true }
        },
        {
          path: '/qa/qaAdd',
          name: 'qa_add',
          component: qaAdd,
          meta: { requiresAuth: true }
        },
        {
          path: '/qa/qaEdit',
          name: 'qa_edit',
          component: qaEdit,
          meta: { requiresAuth: true }
        },
        {
          path: '/system/version',
          name: 'system_version',
          component: systemVersion,
          meta: { requiresAuth: true }
        },
        {
          path: '/shopping/posCombo/list',
          name: 'pos_combo_list',
          component: posComboList,
          meta: { requiresAuth: true }
        },
        {
          path: '/shopping/combo/list',
          name: 'combo_list',
          component: comboList,
          meta: { requiresAuth: true }
        },
        {
          path: '/shopping/combo/add',
          name: 'combo_add',
          component: comboAdd,
          meta: { requiresAuth: true }
        },
        {
          path: '/shopping/combo/edit',
          name: 'combo_edit',
          component: comboEdit,
          meta: { requiresAuth: true }
        },
        {
          path: '/shopping/menu/list',
          name: 'menu_list',
          component: menuList,
          meta: { requiresAuth: true }
        },
        {
          path: '/shopping/menu/item_list',
          name: 'menu_item_list',
          component: menuItemList,
          meta: { requiresAuth: true }
        },
        {
          path: '/shopping/product/list',
          name: 'product_list',
          component: productList,
          meta: { requiresAuth: true }
        },
        {
          path: '/shopping/product/edit',
          name: 'product_edit',
          component: productEdit},
        {
          path: '/shopping/plus/list',
          name: 'plus_list',
          component: plusList,
          meta: { requiresAuth: true }
        },
        {
          path: '/shopping/ordersetting/index',
          name: 'ordersetting_index',
          component: orderSettingIndex,
          meta: { requiresAuth: true },
          children: [
            {
              path: '/shopping/ordersetting/daytypesetting',
              name: 'ordersetting_daytypesetting',
              component: dayTypeSetting,
              meta: { requiresAuth: true }
            },
            {
              path: '/shopping/ordersetting/ordercontrolsetting',
              name: 'ordersetting_ordercontrolsetting',
              component: orderControlSetting,
              meta: { requiresAuth: true }
            },
            {
              path: '/shopping/ordersetting/storeordersetting',
              name: 'ordersetting_storeordersetting',
              component: storeOrderSetting,
              meta: { requiresAuth: true }
            },
            {
              path: '/shopping/ordersetting/storeworktime',
              name: 'ordersetting_storeworktime',
              component: storeWorkTime,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: '/shopping/holiday/index',
          name: 'storeholiday_index',
          component: storeholidayIndex,
          meta: { requiresAuth: true },
          children: [
            {
              path: '/shopping/holiday/poscloselist',
              name: 'storeholiday_poscloselist',
              component: posCloseList,
              meta: { requiresAuth: true }
            },
            {
              path: '/shopping/holiday/list',
              name: 'storeholiday_list',
              component: storeholidayList,
              meta: { requiresAuth: true }
            },
            {
              path: '/shopping/holiday/publicholiday',
              name: 'storeholiday_publicholiday',
              component: StorePublicHolidaySetting,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: '/shopping/store/index',
          name: 'store_index',
          component: storeIndex,
          meta: { requiresAuth: true },
          children: [
            {
              path: '/shopping/store/list',
              name: 'store_list',
              component: storeList,
              meta: { requiresAuth: true }
            },
            {
              path: '/shopping/store/paymentmemo',
              name: 'store_payment_memo',
              component: storePaymentMemo,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: '/shopping/flavor/list',
          name: 'flavor_list',
          component: flavorList,
          meta: { requiresAuth: true }
        },
        {
          path: '/shopping/extra/list',
          name: 'extra_list',
          component: extraList,
          meta: { requiresAuth: true }
        },
        {
          path: '/shopping/flavor/item_list',
          name: 'flavor_item_list',
          component: flavorItemList,
          meta: { requiresAuth: true }
        },
        {
          path: '/information/memberusecoupon/list',
          name: 'information_memberusecoupon_list',
          component: informationMemberUseCouponList,
          meta: { requiresAuth: true }
        },
        {
          path: '/information/tickethistory/list',
          name: 'information_tickethistory_list',
          component: informationTicketHistoryList,
          meta: { requiresAuth: true }
        },
        {
          path: '/information/apporder/list',
          name: 'information_apporder_list',
          component: informationAppOrderList,
          meta: { requiresAuth: true }
        },
        {
          path: '/information/payment/list',
          name: 'information_payment_list',
          component: informationPaymentList,
          meta: { requiresAuth: true }
        },
        {
          path: '/information/payment/Itemlist',
          name: 'information_payment_itemlist',
          component: informationPaymentItemList
        },
        {
          path: '/information/memberAppOrder/list',
          name: 'information_memberAppOrder_list',
          component: informationMemberAppOrderList,
          meta: { requiresAuth: true }
        },
        {
          path: '/information/payforuse/list',
          name: 'information_payforuse_list',
          component: informationPayForUseList,
          meta: { requiresAuth: true }
        },
        {
          path: '/information/areaOrder/list',
          name: 'information_areaOrder_list',
          component: informationAreaOrderList,
          meta: { requiresAuth: true }
        },
        {
          path: '/order/manage/list',
          name: 'order_manage_list',
          component: orderManageList,
          meta: { requiresAuth: true }
        },
        {
          path: '/order/payment/list',
          name: 'order_payment_list',
          component: orderPaymentList,
          meta: { requiresAuth: true }
        },
        {
          path: '/order/period/list',
          name: 'order_period_list',
          component: orderPeriodList,
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: { requiresAuth: false }
    },
    // 當 url path 不符合 router 表的時候，預設轉址到
    // 順序一定要最後面
    { path: '/*', redirect: '/login' }
  ]
})

// 頁面轉跳驗證
router.beforeEach((to, from, next) => {
  // 如果 router 轉跳的頁面需要驗證 requiresAuth: true
  console.log('to=', to.fullPath, '| from=', from.fullPath)
  if (to.matched.some(record => {
    console.log(record.name, record.meta.requiresAuth)
    return record.meta.requiresAuth
  })) {
    // 如果沒有 token
    let token = localStorage.getItem('TOKEN')
    console.log('token?', token)
    if (token === '' || token === 'undefined') {
      // 轉跳到 login page
      next({ path: '/login' })
    } else {
      next() // 往下繼續執行
    }
  } else {
    next() // 往下繼續執行
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js